<template>
    <v-list-item
        v-if="item.type === 'logout'"
        @click="handleLogout"
        :prepend-icon="item.icon"
        link
        :active="isActive"
    >
        <v-list-item-title>{{ item.title }}</v-list-item-title>
    </v-list-item>

    <v-list-item
        v-else-if="item.type === 'action'"
        @click="handleAction"
        :prepend-icon="item.icon"
        link
    >
        <v-list-item-title>{{ item.title }}</v-list-item-title>
    </v-list-item>

    <v-list-item v-else @click="navigate" link :active="isActive">
        <template #prepend>
            <img
                v-if="item.iconImg"
                :src="item.iconImg"
                alt=""
                class="nav-img"
            />
            <v-icon v-else :icon="item.icon" />
        </template>
        <v-list-item-title>{{ item.title }}</v-list-item-title>
    </v-list-item>
</template>

<script>
import { mapActions } from "vuex";
import { useRouter } from "vue-router";
import { showAlertModal } from "@/utils";

export default {
    name: "NavItem",
    props: {
        item: Object,
    },
    data() {
        return {
            router: useRouter(),
        };
    },
    computed: {
        /**
         * Mark this nav item "active" if the current route's path
         * matches item.to. (Use "startsWith" if partial match needed.)
         */
        isActive() {
            return this.$route.path === this.item.to;
        },
    },
    methods: {
        /**
         * Maps Vuex actions from the `auth` module.
         */
        ...mapActions("auth", ["logout"]),
        showAlertModal,
        /**
         * Handles user logout.
         * Calls the Vuex `logout` action and redirects the user to the homepage.
         *
         * @async
         * @returns {Promise<void>}
         */
        async handleLogout() {
            try {
                await this.logout();
                this.$router.push("/");
            } catch (error) {
                console.error("Logout failed:", error);
                this.showAlertModal(
                    this.$store,
                    "Logout failed",
                    "danger",
                    12000,
                    error
                );
            }
        },
        /**
         * Navigates to the given route if `item.to` exists.
         */
        navigate() {
            if (this.item?.to) {
                this.$router.push(this.item.to);
            }
        },
        handleAction() {
            if (typeof this.item.action === "function") {
                this.item.action(); // open external URL
            } else {
                console.warn("Action not defined or not a function");
            }
        },
    },
};
</script>

<style>
.v-list-item__prepend {
    width: 40px !important;
}

.v-list-item__append {
    width: 40px !important;
}

.nav-img {
    width: 22px;
    height: 22px;
    object-fit: contain;
}
</style>
